const fr = {
	login: 'S\'identifier',
	logout: 'Se déconnecter',
	signin: 'se connecter',
	signup: 'S\'inscrire',
	email: 'email',
	emailAddr: 'Adresse électronique',
	password: 'mot de passe',
	rememberMe: 'Souviens-toi de moi',
	forgotYourPwd: 'Mot de passe oublié?',
	signinFacebook: 'Connectez-vous avec Facebook',
	signinGoogle: 'Connectez-vous avec Google',
	dontAccount: 'Vous n\'avez pas de compte?',
	firstName: 'Prénom',
	lastName: 'Nom de famille',
	confirmPwd: 'Confirmez le mot de passe',
	signup_msg: 'En cliquant sur rejoindre maintenant, vous acceptez les',
	digitX_user_agreement: 'Contrat d\'utilisation de DigitXchange',
	privacy_policy: 'Politique de confidentialité',
	and: ' et',
	cookies_policy: 'Politique de cookies',
	have_account: 'Vous avez déjà un compte',
	forgotPwd: 'Mot de passe oublié',
	recoverPwd: 'RÉCUPÉRER MOT DE PASSE',
	forgotPwd_msg: 'Placez votre email dans le champ ci-dessus, nous vous enverrons un lien avec les instructions à suivre.',
	changePwd: 'Changer le mot de passe',
	oldPwd: 'ancien mot de passe',
	newPwd: 'nouveau mot de passe',
	confirmNewPwd: 'Confirmer le nouveau mot de passe',
	user_account: 'Compte d\'utilisateur',
	change_pic: 'Changer l\'image',
	mobile_number: 'Numéro de portable',
	country: 'Pays',
	update_settings: 'mettre à jour les paramètres',
	company: 'Entreprise',
	aboutUs: 'À propos de nous',
	tos: 'TOS',
	copyright: 'droits d\'auteur',
	socialMedia: 'Des médias sociaux',
	forUpdates: 'pour les mises à jour',
	footer_msg_1: 'En vous inscrivant, vous acceptez',
	terms: 'Conditions d\'utilisation',
	contactUs: 'Nous contacter',
	yourEmail: 'Votre email',
	required: 'obligatoire',
	yourMsg: 'Votre message',
	sent: 'Expédié',
	footer_msg_2: 'Tous droits réservés',
	footer_msg_3: 'Tous les noms de produits, marques de commerce et marques déposées appartiennent à leurs propriétaires respectifs',
	doom: 'Doom III',
	filter: 'Filtre',
	add_asset: 'Ajouter un élément',
	request_game: 'Demander un jeu',
	search_msg: 'Désolé, mais rien ne correspond à vos termes de recherche.',
	post: 'Publier',
	asset: 'Atout',
	create: 'Créer',
	character: 'Personnage',
	characters: 'Personnages',
	assets: 'Les atouts',
	profile: 'Profil',
	game: 'Jeu',
	games: 'Jeux',
	currency: 'Devise',
	store: 'Boutique',
	all_time: 'Tout le temps',
	this_month: 'Ce mois-ci',
	trending: 'Tendance',
	item_name: 'Nom de l\'article',
	view_item: 'Regarder l\'objet',
	leaderboard: 'Classement',
	posters: 'Affiches',
	chinese: 'chinois',
	english: 'Anglais',
	japanese: 'Japonais',
	korean: 'coréen',
	german: 'allemand',
	french: 'français',
	spanish: 'Espagnol',
	italian: 'italien',
	russian: 'russe',
	portuguese: 'Portugais',
	hindi: 'hindi',
	arabic: 'arabe',
	buy: 'Acheter',
	subscription: 'Abonnement',
	buy_subscription: 'Acheter un abonnement',
	gift: 'Cadeau',
	xchange: 'Xchange',
	subscription_plan: 'Plan d\'abonnement',
	payment_options: 'Options de paiement',
	cardholder_name: 'Nom du titulaire',
	submit_order: 'Soumettre la commande',
	card_number: 'Numéro de carte',
	cvv: 'CVV',
	expiration_date: 'Date d\'expiration',
	buyXchange: 'Acheter Xchange',
	giftXchange: 'Gift Xchange',
	or: 'ou',
	select: 'Sélectionner',

	search: 'Chercher',
	search_games: 'Rechercher des jeux ...',
	search_assets: 'Rechercher des actifs ...',
	platform: 'Plate-forme',
	total_posts: 'Total des messages',
	total_comments: 'Total des commentaires',
	total_characters: 'Nombre total de caractères',
	total_assets: 'Actif total',
	xchange_currency: 'Xchange Currency',
	subscription_days_remaining: 'Jours d\'abonnement restants',
	total_asset_networth: 'Total des actifs nets',
	total_character_networth: 'Total de caractères Networth',
	most_downloaded: 'Le plus téléchargé',
	recently_added: 'Récemment ajouté',
	genre: 'Genre',
	my_library: 'Ma bibliothèque',
	most_commented: 'le plus commenté',
	most_recent: 'Le plus récent',
	nearing_addition: 'Addition proche',
	create_asset: 'Créer un actif',
	create_character: 'Créer un personnage',
	asset_name: 'Nom de l\'actif',
	asset_type: 'Type d\'actif',
	rarity: 'Rareté',
	enhancements: 'Améliorations',
	add: 'Ajouter',
	currency_type: 'Type de devise',
	price: 'Prix',
	description: 'La description',
	upload_asset: 'Importer l\'élément',
	preview_asset: 'Aperçu de l\'actif',
	main_image: 'Image principale',
	upload_video: 'Télécharger une video',
	upload: 'Télécharger',
	view_demo: 'Voir la démo',
	character_name: 'Le nom du personnage',
	character_type: 'Type de caractère',
	upload_character: 'Télécharger le personnage',
	preview_character: 'Aperçu du caractère',
	race: 'Course',
	class: 'Classe',
	gender: 'Le genre',
	level: 'Niveau',
	showing: 'Montrant',
	of: 'de',
	results: 'résultats',
	featured_characters: 'Personnages en vedette',
	url: 'URL',
	submit: 'Soumettre',
	real_world: 'Monde réel',
	game_currency: 'Monnaie de jeu',
	all: 'Tout',

	edit: 'Éditer',
	save: 'sauver',
	agg_character_networth: 'Caractère agrégé Networth',
	agg_time_played: 'Temps agrégé joué',
	agg_asset_value: 'Valeur d\'actif agrégée',
	enter_character_creation_date: 'Entrez la date de création du personnage',
	in_game_currency: 'Dans la devise du jeu',
	real_world_value: 'Valeur réelle',
	update_character: 'Mettre à jour le personnage',
	item_not_found: 'Objet non-trouvé!',
	ripper: 'Éventreur',
	comments: 'commentaires',
	add_comments: 'Ajoutez des commentaires',
	new_suggested_price: 'Nouveau prix suggéré',
	sort_by: 'Trier par',
	reply: 'Répondre',
	asset_networth: 'Asset Networth',
	join_date: 'Date d\'inscription',
	report: 'rapport',
	first: 'Première',
	last: 'Dernier',
	most_replies: 'La plupart des réponses',
	new_pricing_recommendations: 'Nouvelles recommandations de prix',
	xchange_amount: 'Montant Xchange',
	username: 'Nom d\'utilisateur',
	send_gift: 'Envoyer un cadeau',
	message: 'Message',
	gift_text: 'Personnalisez votre message ici',
	day: 'journée',
	days: 'journées',
	currency_converter: 'Convertisseur de devises',
	from: 'De',
	to: 'À',
	in_game: 'En jeu',
	real_life: 'Vrai vie',
	cvc: 'CVC',
	card: 'Carte',
	per_month: 'Mensuel (3 $ par mois)',
	per_year: 'Annuel (30 $ par an)',
	aboutUs_text: 'DigitXChange est un site Web communautaire qui vise enfin à valoriser la valeur des biens et services numériques via le crowdsourcing. Si vous avez déjà posé la question "combien vaut réellement mon personnage" ou "je me demande ce que serait un commerce équitable avec un autre joueur dans un autre jeu", ne cherchez pas plus loin pour les réponses. Nous espérons que vous apprécierez notre site, participerez à la construction des connaissances du groupe, montrez votre butin durement gagné et attendez avec impatience de découvrir votre valeur nette numérique totale!',
	home: 'Page d\'accueil',
	all_time_characters: 'Personnages de tous les temps',
	this_month_characters: 'Personnages du mois',
	trending_characters: 'Personnages tendance',
	all_time_posters: 'Affiches de tous les temps',
	this_month_posters: 'Affiches du mois',
	trending_posters: 'Affiches tendance',
	
};

export default fr;


// WEBPACK FOOTER //
// ./src/translations/fr.js